import React from "react";
import styled from "styled-components";

import { Link } from "react-router-dom";


import { useTranslation } from 'react-i18next';

const Ul = styled.ul`
  list-style: none;
  display: flex;
  flex-flow: row nowrap;
  padding: 0px;

  li {
    padding: 18px 20px;
    color: #212121;
    font-weight: 500;
    font-size: 14px;
    text-transform: uppercase;  
  }
  li:hover {
    color: #d4c390;
  } 

  li ul {
    display: none;
  }    
  li:hover > ul {
    position: absolute;
    top: 46px;  
    display: block;
    background: #fff;
    width: 150px;
    padding: 0px;
    z-index: 1;
    border-radius: 5px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
    list-style: none; 
  }  
 
  li:hover > ul .submenu {
    margin-top: 20px;
    margin-left: 130px
  }


  //https://codepen.io/clemens/pen/peyQYB
  .nav-wrapper {
    width: auto;
    margin: 0px auto;  
  } 
  .sl-nav {
    display: inline;
  } 
  .sl-nav ul {
    margin: 0;
    padding: 0;
    list-style: none;
    position: relative;
    display: inline-block;
  } 
  .sl-nav li {
    cursor: pointer;
    padding-bottom: 10px;
    font-weight: 500; 
  } 
  .sl-nav li i {
    padding-left: 5px;
  }
  .sl-nav li ul {
    display: none;
  } 
  .sl-nav li:hover ul {
    position: absolute;
    top: 46px;
    right: -10px;
    display: block;
    background: #fff;
    width: 120px;
    padding-top: 0px;
    z-index: 1;
    border-radius: 5px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  }
  .sl-nav li:hover .triangle {
    position: absolute;
    top: 36px;
    right: 0px;
    z-index: 10;
    height: 14px;
    overflow: hidden;
    width: 30px;
    background: transparent;
  }
  .sl-nav li:hover .triangle:after {
    content: '';
    display: block;
    z-index: 20;
    width: 15px;
    transform: rotate(45deg) translateY(0px) translatex(10px);
    height: 15px;
    background: #fff;
    border-radius: 2px 0px 0px 0px;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.2);
  }
  .sl-nav li ul li {
    position: relative;
    text-align: left;
    background: transparent;
    padding: 15px 15px;
    padding-bottom: 0;
    z-index: 2;
    font-size: 15px;
    color: #111;
  }
  .sl-nav li ul li:last-of-type {
    padding-bottom: 15px;
  }
  .sl-nav li ul li span {
    padding-left: 5px;
  }
  .sl-nav li ul li span:hover, .sl-nav li ul li span.active {
    color: #d4c390;
  }
  .sl-flag {
    display: inline-block;
    box-shadow: 0px 0px 3px rgba(0, 0, 0, 0.4);
    width: 17px;
    height: 17px;
    background: #aaa;
    border-radius: 50%;
    position: relative;
    top: 2px;
    overflow: hidden;
  }
  .flag-th { 
    background-size: cover;
    background-position: center center;
    background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAIAAACQkWg2AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjBENDM3ODc5MEQyNjExRTZCNThGODY3NDI3REY2NzA5IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjBENDM3ODdBMEQyNjExRTZCNThGODY3NDI3REY2NzA5Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MEQ0Mzc4NzcwRDI2MTFFNkI1OEY4Njc0MjdERjY3MDkiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MEQ0Mzc4NzgwRDI2MTFFNkI1OEY4Njc0MjdERjY3MDkiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5Q0VGVAAAAVklEQVR42mJ8K6PCQApg+f/lK2ka2CNCSNLA+P//f5I0MDGQCFgKsntIc5KEoBtpNvDwcNLYD1+/fCdNQ0iEy2CLhy9ZBaQ56Y2ABGk2MPLwkKQBIMAAqAkTsLF+BZQAAAAASUVORK5CYII5OTg=");
  }
  
  .flag-usa {
    background-size: cover;
    background-position: center center;
    background: url("data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyZpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuNi1jMTExIDc5LjE1ODMyNSwgMjAxNS8wOS8xMC0wMToxMDoyMCAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENDIDIwMTUgKFdpbmRvd3MpIiB4bXBNTTpJbnN0YW5jZUlEPSJ4bXAuaWlkOjA5QTFEQzU1MEQyRDExRTY4OEE4QTM1OEYwRjlDMUE4IiB4bXBNTTpEb2N1bWVudElEPSJ4bXAuZGlkOjA5QTFEQzU2MEQyRDExRTY4OEE4QTM1OEYwRjlDMUE4Ij4gPHhtcE1NOkRlcml2ZWRGcm9tIHN0UmVmOmluc3RhbmNlSUQ9InhtcC5paWQ6MDlBMURDNTMwRDJEMTFFNjg4QThBMzU4RjBGOUMxQTgiIHN0UmVmOmRvY3VtZW50SUQ9InhtcC5kaWQ6MDlBMURDNTQwRDJEMTFFNjg4QThBMzU4RjBGOUMxQTgiLz4gPC9yZGY6RGVzY3JpcHRpb24+IDwvcmRmOlJERj4gPC94OnhtcG1ldGE+IDw/eHBhY2tldCBlbmQ9InIiPz5NrcfcAAACQElEQVR42pRTTUhUURT+3n33vTc/FOWidtbCmhZaZG2Kyp+xAhcthFpkVEaLnEXrMNoEUbRomblJEioXAxOYGc5omVnkDAiWWWZlYFDBUwfm943zTvfdcchkIv3gwuGcc8/Pd85RUHFlGsBGFJGyEOy+AH+4G59v3gEIqGgLoL/2OE6c7AA8OpZhniOd2wQXXwdFwZpAInJmUWN19b4crDyQtArK1Xx0fFUNDY07c2yw6yz6gq3w1/uA7KI0loojdc5HxnH02G6EWitxTx8Hm2kOoCHxBZG7zejtasGBuu2AQn8FkbLo8KBIEgpUoZOPYd9YBN7DNYKztx/MhZ5+olSKinCk2UvXKKaXU0wrp+9t16lotd9EKTEyWnQ1ldnLN0xFVcvsdAZk56EukRl/FUNm4qOcgrtyB9bv3wOHaDIMWQ2ls6Iye06JGVtM4V+2smfmMqDohZGRZcHOZEtROsdBqxnZ0isBvvniOVESA3O7REkExRKZbEJ8JPqnhSqnhb2yBdu2RXlqwT+fdxgm02FDEjMa/S+JkshkkhYehyn9fspk8UdP8fN0APH7QYRefsOhpg70Ds/Aw5nM6DyPxtAz9BU1wtY39AkK52KjVfy4egssGX6O19V+tOSr0XT7HYYHC2Uv32wpC90LYWs81Ykj5x/g2YZt2PqwHfxMbhci7RNAIiWa1QCvXvIspE7YYKgIRyYRHpqCv9YHHnkyroljWnll/4YTyWvI9RwYmNS4yPpLqHNYK5xAbn3+twADADhWKN7rKHifAAAAAElFTkSuQmCCMTQ4OA==");
  }

  @media (max-width: 768px) {
    flex-flow: column nowrap;
    background-color: #d4c390;
    position: fixed;
    transform: ${({ open }) => (open ? "translateX(0)" : "translateX(100%)")};
    top: 0;
    right: -1px;
    height: 100vh;
    width: 80%;
    padding-top: 3.5rem;
    transition: transform 0.3s ease-in-out;
    align-items: center;
  
    li { 
      color: #fff;
      font-weight: 600;   
      font-size: 20px;
    }
    li:hover { 
      color: #000;  
    }
    li ul {
    display: none;
    }  
    li:hover >  ul {
      position: relative;
      top: 0px; 
      display: block;
      background: none; 
      z-index: 1;
      border-radius: none;
      box-shadow: none;
      list-style: none;
      color: #111;
      animation: fadeIn ease 2s;
      -webkit-animation: fadeIn ease 2s;
      -moz-animation: fadeIn ease 2s;   
    }
    
    li:hover > ul .submenu { 
      margin-left: 0px
    } 
    @keyframes fadeIn {
      0% {
        opacity:0;
      }
      100% {
        opacity:1;
      }
    }
    @-moz-keyframes fadeIn {
      0% {
        opacity:0;
      }
      100% {
        opacity:1;
      }
    } 
    @-webkit-keyframes fadeIn {
      0% {
        opacity:0;
      }
      100% {
        opacity:1;
      }
    }

    li ul li {  
      color: #000;
    }
    li ul li:hover { 
      background-color: #d4c390; 
    }
  }
`

const RightNav = ({ open }) => {
  const { t, i18n } = useTranslation(['translation']);

  const changeLanguage = code => {
    i18n.changeLanguage(code);
  };

  return (
    <Ul open={open}>
      <Link to="/">
        <li> {t("home")}</li>
      </Link>
      <Link to="/our_story">
        <li> {t("our_story")}</li>
      </Link>
      <Link>
        <li className="nav-wrapper">
          {t("products.products")}
          <i className="fa fa-angle-down ml-2" aria-hidden="true"></i>

          <ul>
            <Link to="/thai_market">
              <li> {t("products.thaiMarket")}</li>
            </Link>

            <Link to="/international_market">
              <li>
                {t("products.internationalMarket")}
                <i className="fa fa-angle-right ml-2" aria-hidden="true"></i>

                <ul className="submenu">
                  <Link to="/tuna">
                    <li> {t("tuna.tuna")}</li>
                  </Link>
                  <Link to="/sardine">
                    <li> {t("sardine.sardine")}</li>
                  </Link>
                  <Link to="/mackerel">
                    <li>{t("mackerel.mackerel")}</li>
                  </Link>
                </ul>
              </li>
            </Link>
          </ul>

        </li>
      </Link>

      <Link to="/sustainability">
        <li>{t("sustainability.sustainability")}</li>
      </Link>
      <Link to="/recipes">
        <li>{t("recipes")}</li>
      </Link>
      <Link to="/contact-us">
        <li>{t("contact")}</li>
      </Link>
      <div className="nav-wrapper">
        <div className="sl-nav">
          <ul>
            <li>
              {t("lang")}
              <i className="fa fa-angle-down" aria-hidden="true"></i>
              <div className="triangle"></div>
              <ul>
                <li onClick={() => changeLanguage("en")}>
                  <i className="sl-flag flag-usa">
                    <div id="United States"></div>
                  </i>
                  <span>{t("translation:en")}</span></li>
                <li onClick={() => changeLanguage("th")}>
                  <i className="sl-flag flag-th">
                    <div id="thai"></div>
                  </i>
                  <span>{t("translation:th")}</span>
                </li> 
              </ul>
            </li>
          </ul>
        </div>
      </div>
    </Ul>
  );
};

export default RightNav;
